import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Box, Tabs, mainTheme } from "dash-ui";
import { useLocation, useNavigate } from "react-router-dom";

import { RoutesPath } from "flow-components/routes/routes";
import { getCurrentTabFromSearchParam } from "common/helpers";
import { stickyTopBarStyles } from "containers/properties/helpers/stickyTopBarStyles";

import {
  DEFAULT_MANAGEMENT_TAB_KEY,
  ManagementTabsKeys,
} from "./ManagementTabs.constants";
import ManagementUsersPage from "../../ManagementUsersPage/ManagementUsersPage";
import CmsSettingsContent from "../CmsSettingsContent/CmsSettingsContent";

const TabsBox = styled(Box)<{ top?: number }>`
  border-top: 1px solid ${mainTheme.colors.n30};
  border-bottom: 1px solid ${mainTheme.colors.n30};
  ${stickyTopBarStyles}
`;

function ManagementTabs() {
  const navigate = useNavigate();
  const location = useLocation();
  const currentTab = getCurrentTabFromSearchParam(
    location.search
  ) as ManagementTabsKeys;

  const activeTab = currentTab || DEFAULT_MANAGEMENT_TAB_KEY;
  const { t: tCommonLabels } = useTranslation("common", {
    keyPrefix: "labels",
  });

  const tabsMap: Record<ManagementTabsKeys, () => JSX.Element> = {
    [ManagementTabsKeys.USERS]: () => <ManagementUsersPage />,
    [ManagementTabsKeys.CMS_SETTINGS]: () => <CmsSettingsContent />,
  };

  return (
    <>
      <TabsBox w="100%" pos="sticky" overflow="visible">
        <Tabs
          variation="secondary"
          tabs={[
            {
              key: ManagementTabsKeys.USERS,
              label: tCommonLabels("users"),
            },
            {
              key: ManagementTabsKeys.CMS_SETTINGS,
              label: tCommonLabels("cmsSettings"),
            },
          ]}
          activeTab={activeTab}
          onClick={(key) => navigate(`${RoutesPath.Management}?tab=${key}`)}
        />
      </TabsBox>
      <Box w="100%">{tabsMap[activeTab]() || null}</Box>
    </>
  );
}

export default ManagementTabs;
